//Purpose: This will disable the button after the first click so the user can't double click
//How-To-Use: add data:'enforce-single-click' in your html.erb code
$(document).on('click', '*[data=enforce-single-click]', function(event) {
  event.preventDefault();
  $(event.target).prop('disabled', true);
  //Disabled attribute on the button prevents the form from submitting in all webkit browsers
  $(this).parents('form').submit();
});
